import { useEffect, useState } from 'react';
import ShellHeader from '../components/ShellHeader';

const initialFormState = {
  registrationNumber: '',
  make: '',
  model: '',
  year: '',
  mileage: '',
  name: '',
  email: '',
  telephone: '',
  website: '',
};

function SellYourCarPage({ authUser }) {
  const [form, setForm] = useState(initialFormState);
  const [startedAt, setStartedAt] = useState(Date.now());
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setStartedAt(Date.now());
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!form.name.trim() || !form.email.trim()) {
      setIsError(true);
      setMessage('Please complete the required name and email fields.');
      return;
    }

    try {
      setIsSubmitting(true);
      setIsError(false);
      setMessage('');

      const response = await fetch('/api/sell-your-car', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          registrationNumber: form.registrationNumber,
          make: form.make,
          model: form.model,
          year: form.year,
          mileage: form.mileage,
          name: form.name,
          email: form.email,
          telephone: form.telephone,
          website: form.website,
          startedAt,
        }),
      });

      const payload = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(payload.error || 'Unable to submit your request right now.');
      }

      setForm(initialFormState);
      setStartedAt(Date.now());
      setMessage('Thank you. Your details have been sent and our team will contact you soon.');
    } catch (error) {
      setIsError(true);
      setMessage(error.message || 'Unable to submit your request right now.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="site-shell">
      <ShellHeader authUser={authUser} />

      <main className="content-wrap content-wrap-single">
        <section className="content-page-block sell-car-block">
          <div className="section-header">
            <h2>Sell Your Car</h2>
          </div>

          <p className="sell-car-intro">
            Thinking about selling your vehicle? Complete the form below and our team will be in touch
            with an appraisal.
          </p>

          <form className="sell-car-form" onSubmit={handleSubmit} noValidate>
            <div className="sell-car-grid">
              <label className="sell-car-field">
                <span>Reg Number</span>
                <input
                  type="text"
                  name="registrationNumber"
                  value={form.registrationNumber}
                  onChange={handleInputChange}
                  placeholder="AB12 CDE"
                />
              </label>

              <label className="sell-car-field">
                <span>Make of Car</span>
                <input
                  type="text"
                  name="make"
                  value={form.make}
                  onChange={handleInputChange}
                  placeholder="Ford"
                />
              </label>

              <label className="sell-car-field">
                <span>Model</span>
                <input
                  type="text"
                  name="model"
                  value={form.model}
                  onChange={handleInputChange}
                  placeholder="Fiesta"
                />
              </label>

              <label className="sell-car-field">
                <span>Year</span>
                <input
                  type="number"
                  name="year"
                  value={form.year}
                  onChange={handleInputChange}
                  placeholder="2019"
                  min="1900"
                  max="2100"
                />
              </label>

              <label className="sell-car-field">
                <span>Mileage</span>
                <input
                  type="number"
                  name="mileage"
                  value={form.mileage}
                  onChange={handleInputChange}
                  placeholder="42000"
                  min="0"
                />
              </label>

              <label className="sell-car-field sell-car-required">
                <span>Name</span>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleInputChange}
                  placeholder="Your name"
                  required
                />
              </label>

              <label className="sell-car-field sell-car-required">
                <span>Email</span>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleInputChange}
                  placeholder="you@example.com"
                  required
                />
              </label>

              <label className="sell-car-field">
                <span>Telephone</span>
                <input
                  type="tel"
                  name="telephone"
                  value={form.telephone}
                  onChange={handleInputChange}
                  placeholder="07..."
                />
              </label>
            </div>

            <label className="sell-car-honeypot" aria-hidden="true">
              <span>Website</span>
              <input
                type="text"
                name="website"
                value={form.website}
                onChange={handleInputChange}
                autoComplete="off"
                tabIndex="-1"
              />
            </label>

            <p className="sell-car-note">
              We use anti-spam protections to keep this form secure.
            </p>

            {message && (
              <p className={`status-text ${isError ? 'sell-car-error' : 'sell-car-success'}`}>
                {message}
              </p>
            )}

            <button type="submit" className="sell-car-submit" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </section>
      </main>
    </div>
  );
}

export default SellYourCarPage;
